export const BULK_REQUEST_ORDERS = 'BULK_REQUEST_ORDERS';
export const BULK_ORDERS_NO_UPDATES = 'BULK_ORDERS_NO_UPDATES';
export const BULK_ORDERS_RESET_STATE = 'BULK_ORDERS_RESET_STATE';
export const BULK_ORDERS_RECEIVE_ORDERS = 'BULK_ORDERS_RECEIVE_ORDERS';
export const BULK_UPDATE_RECEIVED_TAB = 'BULK_UPDATED_RECEIVED_TAB';
export const BULK_RESET_TOTAL = 'BULK_RESET_TOTAL';
